import { useTranslation } from 'react-i18next';

import { CurrencyType, StaminaType } from '../../../../constants/currencies';
import { SVGIconType } from '../../../../constants/svgIcon';
import { getWebBoosterVairant } from '../../../../constants/webBoosterType';
import useLocale from '../../../../hooks/useLocale';
import { BalanceType } from '../../../../models/Base';
import { AlbumPartition, Space } from '../../../../models/SpaceStore';
import { WebBoosterType } from '../../../../models/UserStore';
import {
  CurrencyNode,
  FolderBreadcrumbRow,
  FolderBreadcrumbVariant,
  GeneralModal,
  GeneralModalNoButtonVariant,
  GeneralModalYesButtonVariant,
  JoyajoyImage,
  SvgIcon,
} from '../../../Molecules';

import styles from './CreateJourneyModal.module.css';

// type TextInputProps = {
//   value: string;
//   errorMessage?: string;
//   maxLength: number;
//   onChange: (event: ChangeEvent<HTMLInputElement>) => void;
// };

type CreateJourneyModalProps = {
  space: Space | null | undefined;
  webBoosterType: WebBoosterType | undefined;
  breadcrumbs: AlbumPartition[];
  // memoryBoostDays: number;
  // title: TextInputProps;
  currencyType: CurrencyType;
  fee: number;
  // selectedItemCount: number;
  onPrimary: () => void;
  onPressCancel: () => void;
  onClickBreadcrumb: () => void;
  // onPressMemoryBoost: () => void;
  // onPressSelectPractice: () => void;
};

export const CreateJourneyModal = (props: CreateJourneyModalProps) => {
  const {
    // memoryBoostDays,
    space,
    webBoosterType,
    breadcrumbs,
    // title,
    currencyType,
    fee,
    // selectedItemCount,
    onPrimary,
    onPressCancel,
    onClickBreadcrumb,
    // onPressMemoryBoost,
    // onPressSelectPractice,
  } = props;
  const { t } = useTranslation();

  const l = useLocale();
  const spaceIconSource = space?.icon?.publicUrls?.small ?? '';
  const spaceI18nInfo = l(space?.i18nClassroomInfo);

  return (
    <GeneralModal
      isYesNo={true}
      onYes={onPrimary}
      onClose={onPressCancel}
      buttonSetting={{
        noText: t('Cancel'),
        noVariant: GeneralModalNoButtonVariant.Gray,
        yesText: t('OK'),
        yesVariant: GeneralModalYesButtonVariant.Cyan,
      }}
      currencies={[StaminaType.CreationStamina, BalanceType.Token]}
    >
      <div className={styles.journey}>
        <div className={styles.centerContainer}>
          <div className={styles.headerContainer}>
            <SvgIcon name={SVGIconType.Journey} className={styles.headerIcon} />
            <div className={styles.headerText}>
              {t(getWebBoosterVairant(webBoosterType).createTextGame)}
            </div>
          </div>
          <hr />

          <div className={styles.titleImageContainer}>
            <div className={styles.imageWrapper}>
              <JoyajoyImage
                resource={{ uri: spaceIconSource }}
                className={styles.image}
              />
            </div>
            <div className={styles.titleContainer}>
              <div className={styles.spaceName}>{spaceI18nInfo?.name}</div>
              <div className={styles.subtitle}>
                {t(getWebBoosterVairant(webBoosterType).name)}
              </div>
            </div>
          </div>

          <div
            className={styles.folderBreadcrumbRow}
            onClick={onClickBreadcrumb}
          >
            <FolderBreadcrumbRow
              webBoosterType={webBoosterType}
              breadcrumbs={breadcrumbs}
              variant={FolderBreadcrumbVariant.Black}
            />
          </div>

          {/* <p className={styles.titleName}>{t('Journey Name')}</p>
          <TextInput
            value={title.value}
            onChange={title.onChange}
            placeholder={t('Journey Name')}
            style={{
              backgroundColor: '#f1f1f1',
              color: '#000',
            }}
            maxLength={title.maxLength}
            showMaxLength={true}
            errorMessage={title.errorMessage}
          /> */}
          {/* <div className={styles.containerGray} onClick={onPressSelectPractice}>
            <SvgIcon
              name={SVGIconType.PracticeTick}
              className={styles.aiIcon}
            />
            <p className={styles.textNormal}>
              {t('Select Memory Practice')}
            </p>
            <div className={styles.containerRight}>
              <p className={styles.textMinor}>{selectedItemCount}</p>
              <SvgIcon name={SVGIconType.Arrow} className={styles.titleIcon} />
            </div>
          </div> */}
          {/* <p className={styles.textTitle}>{t('JOYAJOY AI Memory Boost')}</p>
          <p className={styles.textMinor}>
            {t('Enhance your memory retention by up to 9 times.')}
          </p>
          <div className={styles.containerGray} onClick={onPressMemoryBoost}>
            <SvgIcon
              name={SVGIconType.MemoryWithAI}
              className={styles.aiIcon}
            />
            <p className={styles.textNormal}>{t('AI Memory Boost')}</p>
            <div className={styles.containerRight}>
              <p className={styles.textMinor}>
                {memoryBoostDays > 0
                  ? `${memoryBoostDays} ${t(
                      memoryBoostDays === 1 ? 'day' : 'days',
                    )}`
                  : t('Off')}
              </p>
              <SvgIcon name={SVGIconType.Arrow} className={styles.titleIcon} />
            </div>
          </div> */}
          {/* <p className={styles.textCaption}>
            {t('Create the Journey of AI Practice?')}
          </p> */}
          <div style={{ marginTop: '8px' }}>
            <CurrencyNode currencyType={currencyType} amount={fee} />
          </div>
        </div>
      </div>
    </GeneralModal>
  );
};
